"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspenseResource = void 0;
/*
 *  Special wrapper object for the React Suspense.
 */
class SuspenseResource {
    constructor(fetchPromise) {
        this.state = 'pending';
        this.promise = fetchPromise
            .then(result => {
            this.result = result;
            this.state = 'fulfilled';
        })
            .catch(error => {
            this.error = error;
            this.state = 'rejected';
        });
    }
    // React Suspense only works correctly if the code behaves in a such way.
    read() {
        switch (this.state) {
            case 'pending':
                throw this.promise;
            case 'rejected':
                throw this.error;
            case 'fulfilled':
                if (!this.result)
                    throw new Error('Suspense resource is fulfilled but contains an unexpected result value.');
                return this.result;
        }
    }
}
exports.SuspenseResource = SuspenseResource;
//# sourceMappingURL=suspense-resource.js.map